import debug from './debug.js'

const noop = () => {}

export default {
  error: console.error.bind(console),
  warn: console.warn.bind(console),
  log: debug ? console.log.bind(console) : noop,
  info: debug ? console.info.bind(console) : noop,
  debug: debug ? console.debug.bind(console) : noop,
  time: debug ? console.time.bind(console) : noop,
  timeEnd: debug ? console.timeEnd.bind(console) : noop,
}
